export type MicrophonePermission = PermissionState | 'unknown';

export async function requestMicrophoneAccess(mediaDevices: Pick<MediaDevices, 'getUserMedia'> = navigator.mediaDevices): Promise<void> {
  // 只在用户点击语音按钮后请求设备权限。探测流立即关闭，录音由识别器接管。
  const stream = await mediaDevices.getUserMedia({ audio: true });
  for (const track of stream.getTracks()) track.stop();
}

export async function readMicrophonePermission(): Promise<MicrophonePermission> {
  try {
    return (await navigator.permissions.query({ name: 'microphone' as PermissionName })).state;
  } catch {
    // 部分浏览器提供语音识别接口，但不支持查询麦克风权限。
    return 'unknown';
  }
}

export function voiceErrorMessage(error: string, permission: MicrophonePermission = 'unknown'): string | null {
  switch (error) {
    case 'aborted':
      return null;
    case 'not-allowed':
      if (permission === 'denied') return '麦克风访问已被阻止，请在本站权限设置中允许麦克风后重试。';
      if (permission === 'granted') return '麦克风权限已允许，但浏览器拒绝启动语音识别服务。请检查浏览器的语音识别支持与设置。';
      return '浏览器未允许启动语音识别。请检查本站麦克风权限及浏览器的语音识别支持。';
    case 'service-not-allowed':
      return '当前浏览器未允许使用语音识别服务。麦克风授权与语音识别服务是两项不同的能力，请检查浏览器的语音识别支持。';
    case 'audio-capture':
      return '无法读取麦克风，请检查麦克风连接及系统录音权限。';
    case 'device-not-found':
      return '当前浏览器未检测到可用麦克风。请检查系统音频输入设备，并确认浏览器可以访问该设备。';
    case 'device-not-readable':
      return '麦克风暂时无法读取，请检查系统录音设置及设备是否被其他程序占用。';
    case 'network':
      return '无法连接语音识别服务，请检查网络后重试。';
    case 'no-speech':
      return '未检测到语音，请靠近麦克风说话后重试。';
    case 'language-not-supported':
      return '当前语音识别服务不支持中文，请检查浏览器的语音语言设置。';
    default:
      return '语音识别未能完成，请稍后重试。';
  }
}
